export * from "./websocketRequests.js";
export * from "./websocketResponses.js";
export * from "./challenge.js";
export var MoveType;
(function (MoveType) {
    MoveType["BLUNDER"] = "blunder";
    MoveType["MISTAKE"] = "mistake";
    MoveType["MISS"] = "miss";
    MoveType["INACCURACY"] = "inaccuracy";
    MoveType["GOOD"] = "good";
    MoveType["EXCELLENT"] = "excellent";
    MoveType["BEST"] = "best";
    MoveType["GREAT"] = "great";
    MoveType["BRILLIANT"] = "brilliant";
    MoveType["BOOK"] = "book";
})(MoveType || (MoveType = {}));
export var TermAction;
(function (TermAction) {
    TermAction["ALLOW"] = "allow";
    TermAction["ALLOW_UNDEFENDED"] = "allow undefended";
    TermAction["MISS"] = "miss";
    TermAction["BETTER_WAY"] = "better way";
    TermAction["PERFORM"] = "perform";
    TermAction["POSPONE"] = "pospone";
    TermAction["CREATE"] = "create";
    TermAction["PERFORM_THREAT"] = "threat";
    TermAction["MISS_THREAT"] = "miss threat";
    TermAction["ALLOW_THREAT"] = "allow threat";
})(TermAction || (TermAction = {}));
// export enum AffectNextMove {
//   FORCE = "force",
//   OFFER_TRADE = "offer trade",
// }
export var ChessTermType;
(function (ChessTermType) {
    // Change in material
    ChessTermType["OFFER_TRADE"] = "offer trade";
    ChessTermType["OFFER_TRADE_SAME_PIECE"] = "offer trade same piece";
    // Attacks
    ChessTermType["KICK_PIECE"] = "kick";
    ChessTermType["TEMPO"] = "tempo gain";
    ChessTermType["THREATEN_PIECE"] = "threaten piece";
    ChessTermType["THREATEN_TRADE"] = "threaten trade";
    ChessTermType["THREATEN_CHECKMATE"] = "threaten checkmate";
    ChessTermType["CHECK"] = "check";
    // Pawns
    ChessTermType["DOUBLE_PAWN"] = "double pawn";
    ChessTermType["FORCE_DOUBLE_PAWN"] = "force double pawn";
    ChessTermType["BACKWARD_PAWN"] = "backward pawn";
    ChessTermType["PAWN_CHAIN"] = "pawn chain";
    ChessTermType["ATTACK_PAWN_CHAIN"] = "attack pawn chain";
    ChessTermType["BLOCKADE"] = "blockade";
    ChessTermType["ISOLATED_PAWN"] = "isolated pawn";
    ChessTermType["FORCE_ISOLATE_PAWN"] = "force isolate pawn";
    ChessTermType["CONNECT_PAWN"] = "connect pawn";
    ChessTermType["OFFER_TRADE_CONNECT_PAWN"] = "offer trade connect pawn";
    ChessTermType["PASSED_PAWN"] = "passed pawn";
    ChessTermType["OFFER_TRADE_PASSED_PAWN"] = "offer trade passed pawn";
    // Defence
    ChessTermType["BLOCK"] = "block";
    ChessTermType["DEFEND"] = "defend";
    ChessTermType["MOVE_TO_SAFETY"] = "move to safety";
    ChessTermType["IN_CHECK_MOVE_TO_SAFETY"] = "in check move to safety";
    ChessTermType["IN_CHECK_BLOCK"] = "in check block";
    ChessTermType["IN_CHECK_ESCAPE"] = "in check escape";
    ChessTermType["COUNTER_ATTACK"] = "counter attack";
    // Piece placement
    ChessTermType["CENTER_CONTROL"] = "center control";
    ChessTermType["KING_SAFETY"] = "king safety";
    ChessTermType["BAD_KING_SAFETY"] = "bad king safety";
    ChessTermType["OUTPOST"] = "outpost";
    ChessTermType["PIECE_ACTIVITY"] = "piece activity";
    ChessTermType["CASTLE"] = "castle";
    ChessTermType["CAN_CASTLE"] = "can_castle";
    ChessTermType["PREVENT_CASTLING"] = "prevent_castling";
    // Strategic Concepts
    ChessTermType["OPEN_FILE"] = "open file";
    ChessTermType["OPEN_DIAGONAL"] = "open diagonal";
    ChessTermType["CHALLENGE_OPEN_FILE"] = "challenge open file";
    ChessTermType["CHALLENGE_OPEN_DIAGONAL"] = "challenge open diagonal";
    ChessTermType["SACRIFICE"] = "sacrifice";
    ChessTermType["IGNORE_THREAT"] = "ignore threat";
    // BAD_SACRIFICE = "bad sacrifice",
    ChessTermType["CONNECT_ROOKS"] = "connect rooks";
    ChessTermType["CONNECT_ROOKS_BACK_RANK"] = "connect rooks back rank";
    ChessTermType["CONNECT_QUEEN_AND_BISHOP"] = "connect queen and bishop";
    // Opening Concepts
    ChessTermType["BOOK_MOVE"] = "book move";
    ChessTermType["DEVELOP_QUEEN_EARLY"] = "develop queen early";
    ChessTermType["DEVELOPMENT"] = "development";
    ChessTermType["ACTIVATE_ROOK"] = "activate rook";
    ChessTermType["ACTIVATE_QUEEN"] = "activate queen";
    ChessTermType["MOVE_DEVELOPED_PIECE"] = "move developed piece";
    ChessTermType["BAD_OPENING_MOVE"] = "bad opening move";
    // Ending game
    ChessTermType["CHECKMATE"] = "checkmate";
    ChessTermType["FOLLOW_CHECKMATE"] = "follow checkmate";
    ChessTermType["DRAW"] = "draw";
    ChessTermType["STALE_MATE"] = "stale mate";
    ChessTermType["THREEFOLD_REPETITION"] = "threefold repetition";
    ChessTermType["TIME_UP"] = "time up";
    ChessTermType["TRADE"] = "trade";
    ChessTermType["BAD_TRADE"] = "bad trade";
    ChessTermType["RETAKE"] = "retake";
    ChessTermType["TAKES_BACK"] = "takes back";
    ChessTermType["DIRECT_MATERIAL_WIN"] = "direct material win";
    ChessTermType["MATERIAL_WIN"] = "material win";
    ChessTermType["EVENTUAL_MATERIAL_WIN"] = "eventual material win";
    // Tactical Concepts
    ChessTermType["TACTIC"] = "tactic";
    // TACTIC_THREAT = "tactic threat",
    ChessTermType["FORK"] = "fork";
    ChessTermType["PIN"] = "pin";
    ChessTermType["SKEWER"] = "skewer";
    ChessTermType["DOUBLE_ATTACK"] = "double attack";
    ChessTermType["DISCOVERED_ATTACK"] = "discovered attack";
    ChessTermType["UNPIN"] = "unpin";
    ChessTermType["REMOVE_DEFENDER"] = "remove defender";
    ChessTermType["OVERLOADING"] = "overloading";
    ChessTermType["DEFLECTION"] = "deflection";
    ChessTermType["TRAPPED_PIECE"] = "trapped piece";
    // Initiative changes
    ChessTermType["INITIATIVE_CHANGE"] = "initiative change";
    ChessTermType["EQUAL_TO_ADVANTAGE"] = "equal to advantage";
    ChessTermType["ADVANTAGE_TO_EQUAL"] = "advantage to equal";
    ChessTermType["NONE"] = "none";
})(ChessTermType || (ChessTermType = {}));
// export interface Commentary {
//   comment: string; // The textual commentary on the move or position
//   terms: ChessTerm[]; // Array of terms to highlight, with associated coordinates
//   scoreDiff: number;
// }
export const OPTIONAL_MOVE = "-";
//# sourceMappingURL=index.js.map